import TopImage from '../../components/layout/TopImage/TopImage';
import Hr from '../../components/ui/Hr/Hr';
import Section from '../../components/layout/Section/Section';
import MessageSection from '../../components/display/MessageSection/MessageSection';
import RecruitSection from '../../components/display/RecruitSection/RecruitSection';
import OtherSection from '../../components/display/OtherSection/OtherSection';
import NewsSection from '../../components/display/NewsSection/NewsSection';
import ServiceSection from '../../components/display/ServiceSection/ServiceSection';
import { Container } from '@mui/material';

interface Props {
  children?: React.ReactElement<unknown>;
}

export default function Top(props: Props) {
  return (
    <>
      <TopImage />

      <Section color='dark'>
        <Container>
          <MessageSection />
        </Container>
      </Section>

      <Section color='dark' backgroundImage='url(/assets/images/service.jpg)' isBackgroundCover>
        <Container>
          <ServiceSection />
        </Container>
      </Section>

      <Hr />

      <Section color='light' height={'500px'}>
        <Container>
          <NewsSection />
        </Container>
      </Section>

      <Hr />

      <Section color='dark' height={'500px'} backgroundImage='url(/assets/images/recruit.jpg)' isBackgroundCover>
        <Container>
          <RecruitSection />
        </Container>
      </Section>

      <Hr />

      <Section color='light' height={'200px'}>
        <Container>
          <OtherSection />
        </Container>
      </Section>
    </>
  )
}